import getOrders from '../../axios/orderview'
import getOrdersUnpaid from '../../axios/orderview/ordersUnpaid'
import { addOrders, addPreOrdersDays, addPreOrdersToday, addUnpaidOrders, setOrderPublicId, setOrders, setOrdersLoading, setOrdersTotalLength, setPreOrdersDaysTotalLength, setPreOrdersToday, setPreOrdersTodayTotalLength, setShowTodayPreOrdersModal, setUnpaidOrders, setUnpaidOrdersTotalLength } from '../../action/order'
import { retrieveErrorFromApi } from '../../../helper'
import { jwtContainsAnyRole } from '../../../helper/jwt'
import { setAppErrors } from '../../action/system'
import createOrder from '../../axios/order/post'
import updateOrder from '../../axios/order/put'
import { setOrdersCounterOrders, setPreOrdersCounter, setUnpaidOrdersCounterOrders } from '../../action/ordersCounter'
import confirmOrderPayments from '../../axios/order/confirmOrderPayments'
import { fetchPrintSettingsThunk } from '../printReceipt'
import { getInvoicesThunk } from '../invoice'
import updateUnpaidOrder from '../../axios/order/updateUnpaidOrder'
import { logger } from '../../../logger/logger'
import updateOrderPayments from '../../axios/order/payments/put'
import { setRoomChargeOrderId } from '../../action/roomCharge'
import { ROOM_CHARGE_PAYMENT_METHOD } from '../../../component/RoomCharge/constants'

export const getOrdersThunk = (dateFrom, dateTo, paymentMethod, status, excludedStatus, orderType, deliveryPartnerType = null, processedByUsername, processedByUsernameWithEmpty, page, size, reverseSort = false, closed, withOnlyRegisteredPreOrders, salesTransferState = null) => (dispatch, getState) => {
	dispatch(setOrdersLoading(true))
	const modifiedPaymentMethod = paymentMethod === 'EC_TERMINAL' ? 'EC_TERMINAL,TAP_TO_PAY' : paymentMethod
	return getOrders({
		dateFrom, dateTo, paymentMethod: modifiedPaymentMethod, status, excludedStatus, orderType, deliveryPartnerType, processedByUsername, processedByUsernameWithEmpty, page, size, reverseSort, closed, withOnlyRegisteredPreOrders, salesTransferState,
	}).then(res => {
		if (reverseSort === getState().orderfilter.reverse) {
			dispatch(addOrders(res.data))
			if (res.headers['x-orders-total']) {
				dispatch(setOrdersTotalLength(parseInt(res.headers['x-orders-total'])))
			}
		}
		dispatch(setOrdersLoading(false))
	}).catch(error => {
		dispatch(setOrdersLoading(false))
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getViaSetOrdersThunk = (dateFrom, dateTo, paymentMethod, status, isCancelled, orderType, processedByUsername, reverseSort = true, page, size, closed) => dispatch => {
	return getOrders({ dateFrom, dateTo, paymentMethod, status, isCancelled, orderType, processedByUsername, reverseSort, page, size, closed })
		.then(res => {
			dispatch(setOrders(res.data))
			if (res.headers['x-orders-total']) {
				dispatch(setOrdersTotalLength(parseInt(res.headers['x-orders-total'])))
			}
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const storeOrderThunk = (data, hasModalLogin) => (dispatch, getState) => {
	return createOrder(data, hasModalLogin)
		.then(res => {
			const ecTerminalPayment = data?.payments?.find(payment => payment.method === 'EC_TERMINAL')
			if (ecTerminalPayment) {
				logger.info(`Create order: orderId=${res.data.remoteResponse.orderId} paymentId=${ecTerminalPayment?.id} totalPrice=${ecTerminalPayment?.total} companyIndex=${getState().login.companyIndex}`)
			}
			dispatch(setOrderPublicId(res.data.remoteResponse?.publicId))
			if (data.paymentMethod === ROOM_CHARGE_PAYMENT_METHOD) {
				dispatch(setRoomChargeOrderId(res.data.remoteResponse.orderId))
			}
			return res.data.remoteResponse.orderId
		})
		.catch(error => {
			const errorStatusCode = error.response?.data?.apierror?.errorStatusCode
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
			if (errorStatusCode === 'terminal_payment_session_invalid') {
				const paymentEC = data.payments.find(payment => payment.method === 'EC_TERMINAL')
				logger.error(`Create order: paymentId=${paymentEC?.id} totalPrice=${paymentEC?.total} companyIndex=${getState().login.companyIndex}`)
			} else if (errorStatusCode === 'qr_payment_session_invalid') {
				const paymentQrCode = data.payments.find(payment => payment.method === 'QR_CODE')
				logger.error(`Create order: paymentId=${paymentQrCode?.id} totalPrice=${paymentQrCode?.total} companyIndex=${getState().login.companyIndex}`)
			}
			throw new Error(error.response?.data?.apierror?.message)
		})
}

export const updateOrderThunk = (orderId, data) => (dispatch, getState) => {
	return updateOrder(orderId, data)
		.then(res => {
			dispatch(setOrderPublicId(res.data.remoteResponse?.publicId))
			return res.data.remoteResponse.orderId
		})
		.catch(error => {
			const errorStatusCode = error.response?.data?.apierror?.errorStatusCode
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
			if (errorStatusCode === 'terminal_payment_session_invalid') {
				const paymentEC = data.payments.find(payment => payment.method === 'EC_TERMINAL')
				logger.error(`Update order: paymentId=${paymentEC?.id} totalPrice=${paymentEC?.total} companyIndex=${getState().login.companyIndex}`)
			}
			throw new Error(error.response?.data?.apierror?.message)
		})
}

export const confirmOrderPaymentsThunk = (orderId, paymentData, orderData) => dispatch => {
	const isEcTerminalPaymentMethod = paymentData?.payments[0]?.method === 'EC_TERMINAL'
	const isQrCodePaymentMethod = paymentData?.payments[0]?.method === 'QR_CODE'
	const isInvoiceMethod = paymentData?.payments[0]?.method === 'INVOICE'
	const isTapToPayPaymentMethod = paymentData?.payments[0]?.method === 'TAP_TO_PAY'
	return confirmOrderPayments(orderId, paymentData)
		.then(res => {
			if (!isEcTerminalPaymentMethod && !isQrCodePaymentMethod && !isTapToPayPaymentMethod) {
				dispatch(fetchPrintSettingsThunk(orderId, orderData))
			}
			if (isInvoiceMethod) {
				dispatch(getInvoicesThunk(0, 10))
			}
			dispatch(setOrderPublicId(res?.data?.remoteResponse?.publicId))
			return res?.data?.remoteResponse?.publicId
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const resetOrdersThunk = () => {
	return (dispatch) => {
		dispatch(setOrders([]))
		dispatch(setOrdersTotalLength(0))
	}
}

export const getNotAcceptOrdersThunk = (dateFrom, dateTo, paymentMethod, status, orderType, processedByUsername, processedByUsernameWithEmpty, page, size) => (dispatch, getState) => {
	return getOrders({
		dateFrom, dateTo, paymentMethod, status, orderType, processedByUsername, processedByUsernameWithEmpty, closed: false, reverseSort: false, page, size,
	}).then(res => {
		dispatch(setOrdersCounterOrders(res.data.map(order => order.orderId)))
	}).catch(error => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getPreOrdersTodayThunk = (dateFrom, dateTo, orderType, page, size, reverseSort = false, closed) => (dispatch, getState) => {
	return getOrders({
		dateFrom, dateTo, orderType, page, size, reverseSort, closed, isPreOrder: true,
	}).then(res => {
		dispatch(addPreOrdersToday(res.data))
		if (res.headers['x-orders-total']) {
			dispatch(setPreOrdersTodayTotalLength(parseInt(res.headers['x-orders-total'])))
		}
	}).catch(error => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getPreOrdersDaysThunk = (dateFrom, dateTo, orderType, page, size, reverseSort = false, closed) => (dispatch, getState) => {
	return getOrders({
		dateFrom, dateTo, orderType, page, size, reverseSort, closed, isPreOrder: true,
	}).then(res => {
		dispatch(addPreOrdersDays(res.data))
		if (res.headers['x-orders-total']) {
			dispatch(setPreOrdersDaysTotalLength(parseInt(res.headers['x-orders-total'])))
		}
	}).catch(error => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getPreOrdersCounterThunk = (dateFrom, dateTo, orderType, status, closed, page, size) => (dispatch, getState) => {
	return getOrders({
		dateFrom, dateTo, orderType, status, closed, page, size, isPreOrder: true,
	}).then(res => {
		if (res.headers['x-orders-total']) {
			dispatch(setPreOrdersCounter(parseInt(res.headers['x-orders-total'])))
		}
	}).catch(error => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getViaPreOrdersTodayThunk = (dateFrom, dateTo, status, excludedStatus, orderType, page, size, reverseSort = false, isPreorder = false, closed = false) => (dispatch, getState) => {
	const accessToken = getState().core?.auth?.accessToken
	const hasRoleChangeOrder = !!jwtContainsAnyRole(accessToken, ['ORDERS_WRITE', 'DELIVERY_SERVICE_WRITE'])

	return hasRoleChangeOrder &&
		getOrders({
			dateFrom, dateTo, paymentMethod: null, status, excludedStatus, orderType, processedByUsername: null, processedByUsernameWithEmpty: null, reverseSort, closed, isPreOrder: true, withOnlyRegisteredPreorders: false, page, size,
		}).then(res => {
			dispatch(setPreOrdersToday(res.data))
			if (res.headers['x-orders-total']) {
				res.headers['x-orders-total'] > 0 && dispatch(setShowTodayPreOrdersModal(true))
				dispatch(setPreOrdersTodayTotalLength(parseInt(res.headers['x-orders-total'])))
			}
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getUnpaidOrdersThunk = (dateFrom, dateTo, paymentMethod, status, excludedStatus, orderType, processedByUsername, page, size, reverseSort = false, closed, isPaid) => (dispatch, getState) => {
	return getOrders({
		dateFrom, dateTo, paymentMethod, status, excludedStatus, orderType, processedByUsername, page, size, reverseSort, closed, isPaid,
	}).then(res => {
		if (reverseSort === getState().orderfilter.reverse) {
			dispatch(addUnpaidOrders(res.data))
			if (res.headers['x-orders-total']) {
				dispatch(setUnpaidOrdersTotalLength(parseInt(res.headers['x-orders-total'])))
			}
		}
	}).catch(error => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getUnpaidOrdersByRangeThunk = (dateFrom, dateTo) => dispatch => {
	return getOrdersUnpaid(dateFrom, dateTo).then(res => {
		dispatch(setUnpaidOrders(res.data))
		dispatch(setUnpaidOrdersTotalLength(res.data.length))
	}).catch(error => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getUnpaidOrdersCounterThunk = (dateFrom, dateTo, orderType, excludedStatus, status, closed, isPaid, page, size) => (dispatch, getState) => {
	return getOrders({
		dateFrom, dateTo, orderType, excludedStatus, status, closed, isPaid, page, size,
	}).then(res => {
		dispatch(setUnpaidOrdersCounterOrders(res.data.map(order => order.orderId)))
	}).catch(error => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const updateUnpaidOrderThunk = (orderId, data, hasModalLogin) => (dispatch) => {
	return updateUnpaidOrder(orderId, data, hasModalLogin)
		.then(res => {
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateOrderPaymentsThunk = (orderId, paymentData, printData) => (dispatch, getState) => {
	return updateOrderPayments(orderId, paymentData)
		.then(res => {
			const updatedOrderId = res.data.remoteResponse.orderId
			const isEcTerminalPaymentMethod = paymentData?.payments[0]?.method === 'EC_TERMINAL'
			const isQrCodePaymentMethod = paymentData?.payments[0]?.method === 'QR_CODE'
			const isTapToPayPaymentMethod = paymentData?.payments[0]?.method === 'TAP_TO_PAY'
			if (!isEcTerminalPaymentMethod && !isQrCodePaymentMethod && !isTapToPayPaymentMethod) {
				dispatch(fetchPrintSettingsThunk(updatedOrderId, printData))
			}
			dispatch(setOrderPublicId(res.data.remoteResponse?.publicId))
			return updatedOrderId
		})
		.catch(error => {
			const errorStatusCode = error.response?.data?.apierror?.errorStatusCode
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
			if (errorStatusCode === 'terminal_payment_session_invalid') {
				const paymentEC = paymentData.payments.find(payment => payment.method === 'EC_TERMINAL')
				logger.error(`Update order payments: paymentId=${paymentEC?.id} totalPrice=${paymentEC?.total} companyIndex=${getState().login.companyIndex}`)
			}
			throw new Error(error.response?.data?.apierror?.message)
		})
}
